<template>
    <b-overlay :show="loadProcessing>0" z-index="2147483647" style="height: 100%"
               opacity="0.02" variant="white"
    >
        <div class="tools-container no-print">
            <b-alert :show="err" :variant="errVariant" class="mb-4">{{errText}}</b-alert>
            <b-button v-show="docBlankUid>=0" variant="primary" @click="btnPrintClicked">Печать</b-button>
            <b-button variant="secondary" @click="btnCloseClicked" class="ml-2">Закрыть</b-button>
        </div>

        <!--Заявление на открытие 1 фазного бытового абонента РУС -->
        <div v-if="docBlankUid===0 && lang==='ru'" class="parent-container">
            <div>
                <div class="d-inline-block">
                    <span class="font-weight-bolder">Заявка №: {{docBlankUid+"-"+registrationNum}}<br/></span>
                    <span>от {{this.dt}}</span>
                </div>
                <div class="float-right w-300px clear-fix">
                    <p>
                        Начальнику {{resDeclension1}}<br/>
                        {{resHeadInfoDeclension1}}<br/>
                        Заявитель: <span class="font-weight-bolder">{{subscriber}}</span><br/>
                        Адрес: <span class="font-weight-bolder">{{address}}</span><br/>
                        Номер телефона: <span class="font-weight-bolder">{{phoneNumbers}}</span><br/>
                    </p>
                </div>
            </div>
            <div class="clear-fix"/>
            <div class="mt-5">
                <h3 class="text-center">Заявление</h3>
            </div>
            <div class="mt-5">
                <p style="text-indent: 50px; text-align: justify; margin-bottom: 0">
                    Прошу Вас дать разрешение на установку электрического счетчика, произвести
                    регистрацию и подключение к электрическим сетям 0,23 кВ, как новый абонент.
                </p>
                <ul class="ml-15">
                    <li>Копия паспорта заявителя (*)</li>
                    <li>Копия документа на право устанавливаемого на недвижимое имущество (*)</li>
                    <li>Копия справки с места жительства (*)</li>
                </ul>
            </div>
            <div class="mt-10">
                Дата: {{this.dtShort}} г.
                <span class="float-right mr-20">{{subscriber}}
                    <span class="ml-5">____________________</span>
                </span>
            </div>
            <div style="margin-top: 30px; width: 100%; border-bottom: #000 dotted 2px"></div>
            <div class="text-center font-weight-bolder font-size-sm mt-1">ОТРЫВНОЙ ТАЛОН (передается заявителю)</div>
            <div class="mt-3 w-100">
                <div class="d-flex flex-row justify-content-between w-100">
                    <div class="mt-2">
                        <img src="media/logos/logo.jpg" width="60" height="60"/>
                    </div>
                    <div class="w-225px mt-4">
                        <h3 class="font-weight-bolder mb-0">Заявка №: {{docBlankUid+"-"+registrationNum}}<br/></h3>
                        <span>Дата заявки: {{dtShort}}</span>
                    </div>
                    <div class="w-450px">
                        <div class="p-1 ml-22 font-size-sm overflow-auto" style="border: #000 1px dotted">
                            <img :src="getImgLink()" width="70" height="70" class="float-left d-block"/>
                            <span class="d-block mt-5 ml-24">Для отслеживания статуса заявки перейдите на сайт
                                kyzmat.oshelectro.kg или отсканируйте QR-код</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="clear-fix"/>
            <div class="mt-3">
                <div class="float-left">Данные заявителя:</div>
                <div class="ml-2 d-inline-block pb-0 overflow-hidden"
                     style="border-bottom: #000 solid 1px; width: 83.5%">
                    {{subscriber}}, {{address}}, {{phoneNumbers}}
                </div>

            </div>
            <div class="mt-2">
                <span>Заявка принята:&nbsp; {{createdByUser}}&nbsp; _________________</span>
            </div>
            <div class="mt-3" style="font-size: 8pt">
                <span>{{company}}, {{companyContactAddress}}, {{companyContactPhoneNumbers}}</span>
                <span class="float-right">{{companyWebSite}}</span>
            </div>
            <div style="margin-top: 10px; width: 100%; border-bottom: #000 dotted 2px"></div>
        </div>

        <!--Заявление на открытие 1 фазного бытового абонента КЫРГ -->
        <div v-if="docBlankUid===0 && lang==='kg'" class="parent-container">
            <div>
                <div class="d-inline-block">
                    <span class="font-weight-bolder">Арыз №: {{docBlankUid+"-"+registrationNum}}<br/></span>
                    <span>{{this.dt}}</span>
                </div>
                <div class="float-right w-300px clear-fix">
                    <p>
                        {{resDeclension1}} башчысы<br/>
                        {{resHeadInfoDeclension1}}<br/>
                        Жазуучу: <span class="font-weight-bolder">{{subscriber}}</span><br/>
                        Дареги: <span class="font-weight-bolder">{{address}}</span><br/>
                        Телефон номери: <span class="font-weight-bolder">{{phoneNumbers}}</span><br/>
                    </p>
                </div>
            </div>
            <div class="clear-fix"/>
            <div class="mt-5">
                <h3 class="text-center">Арыз</h3>
            </div>
            <div class="mt-5">
                <p style="text-indent: 50px; text-align: justify; margin-bottom: 0">
                    0,23 кВ электр тармактарына жаңы абонент катары электр эсептегич орнотууга, каттоодон өткөрүүгө жана
                    кошулууга уруксат берүүңүздөрдү суранам.
                </p>
                <ul class="ml-15">
                    <li>Паспорттун көчүрмөсү (*)</li>
                    <li>Кыймылсыз мүлккө белгилөө укугу жөнүндө документтин көчүрмөсү (*)</li>
                    <li>Жашаган жеринен күбөлүктүн көчүрмөсү (*)</li>
                </ul>
            </div>
            <div class="mt-10">
                Датасы: {{this.dtShort}}-ж.
                <span class="float-right mr-20">{{subscriber}}
                    <span class="ml-5">____________________</span>
                </span>
            </div>
            <div style="margin-top: 30px; width: 100%; border-bottom: #000 dotted 2px"></div>
            <div class="text-center font-weight-bolder font-size-sm mt-1">Арыз берүүчүгө берилүүчү талон</div>
            <div class="mt-3 w-100">
                <div class="d-flex flex-row justify-content-between w-100">
                    <div class="mt-2">
                        <img src="media/logos/logo.jpg" width="60" height="60"/>
                    </div>
                    <div class="w-225px mt-4">
                        <h3 class="font-weight-bolder mb-0">Арыз №: {{docBlankUid+"-"+registrationNum}}<br/></h3>
                        <span>{{dtShort}}</span>
                    </div>
                    <div class="w-450px">
                        <div class="p-1 ml-22 font-size-sm overflow-auto" style="border: #000 1px dotted">
                            <img :src="getImgLink()" width="70" height="70" class="float-left d-block"/>
                            <span class="d-block mt-2 ml-24">Тиркеменин статусуна көз салуу үчүн kyzmat.oshelectro.kg
                                сайтына кириңиз же болбосо QR-кодду сканерлеңиз.</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="clear-fix"/>
            <div class="mt-3">
                <div class="float-left">Арыз берүүчү жөнүндө маалымат:</div>
                <div class="ml-2 d-inline-block pb-0 overflow-hidden"
                     style="border-bottom: #000 solid 1px; width: 71.5%">
                    {{subscriber}}, {{address}}, {{phoneNumbers}}
                </div>

            </div>
            <div class="mt-2">
                <span>Арыз кабыл алуучу:&nbsp; {{createdByUser}} &nbsp;_________________</span>
            </div>
            <div class="mt-3" style="font-size: 8pt">
                <span>{{company}}, {{companyContactAddress}}, {{companyContactPhoneNumbers}}</span>
                <span class="float-right">{{companyWebSite}}</span>
            </div>
            <div style="margin-top: 10px; width: 100%; border-bottom: #000 dotted 2px"></div>
        </div>

        <!--Заявление на открытие 3х фазного бытового абонента (до 10кВт) РУС-->
        <div v-if="docBlankUid===1 && lang==='ru'" class="parent-container">
            <div>
                <div class="d-inline-block">
                    <span class="font-weight-bolder">Заявка №: {{docBlankUid+"-"+registrationNum}}<br/></span>
                    <span>от {{this.dt}}</span>
                </div>
                <div class="float-right w-300px clear-fix">
                    <p>
                        Начальнику {{resDeclension1}}<br/>
                        {{resHeadInfoDeclension1}}<br/>
                        Заявитель: <span class="font-weight-bolder">{{subscriber}}</span><br/>
                        Адрес: <span class="font-weight-bolder">{{address}}</span><br/>
                        Номер телефона: <span class="font-weight-bolder">{{phoneNumbers}}</span><br/>
                    </p>
                </div>
            </div>
            <div class="clear-fix"/>
            <div class="mt-5">
                <h3 class="text-center">Заявление</h3>
            </div>
            <div class="mt-5">
                <p style="text-indent: 50px; text-align: justify; margin-bottom: 0">
                    Прошу Вас дать разрешение на получение технических условий на электроснабжение жилого дома для
                    бытовых нужд на _____ кВт и на установку электрического счетчика, регистрацию и подключение к
                    электрическим сетям 0,4 кВ, как новый абонент.
                </p>
                <ul class="ml-15">
                    <li>Копия паспорта заявителя (*)</li>
                    <li>Копия документа на право устанавливаемого на недвижимое имущество (*)</li>
                    <li>Копия справки с места жительства (*)</li>
                </ul>
            </div>
            <div class="mt-10">
                Дата: {{this.dtShort}} г.
                <span class="float-right mr-20">{{subscriber}}
                    <span class="ml-5">____________________</span>
                </span>
            </div>
            <div style="margin-top: 30px; width: 100%; border-bottom: #000 dotted 2px"></div>
            <div class="text-center font-weight-bolder font-size-sm mt-1">ОТРЫВНОЙ ТАЛОН (передается заявителю)</div>
            <div class="mt-3 w-100">
                <div class="d-flex flex-row justify-content-between w-100">
                    <div class="mt-2">
                        <img src="media/logos/logo.jpg" width="60" height="60"/>
                    </div>
                    <div class="w-225px mt-4">
                        <h3 class="font-weight-bolder mb-0">Заявка №: {{docBlankUid+"-"+registrationNum}}<br/></h3>
                        <span>Дата заявки: {{dtShort}}</span>
                    </div>
                    <div class="w-450px">
                        <div class="p-1 ml-22 font-size-sm overflow-auto" style="border: #000 1px dotted">
                            <img :src="getImgLink()" width="70" height="70" class="float-left d-block"/>
                            <span class="d-block mt-5 ml-24">Для отслеживания статуса заявки перейдите на сайт
                                kyzmat.oshelectro.kg или отсканируйте QR-код</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="clear-fix"/>
            <div class="mt-3">
                <div class="float-left">Данные заявителя:</div>
                <div class="ml-2 d-inline-block pb-0 overflow-hidden"
                     style="border-bottom: #000 solid 1px; width: 83.5%">
                    {{subscriber}}, {{address}}, {{phoneNumbers}}
                </div>

            </div>
            <div class="mt-2">
                <span>Заявка принята:&nbsp; {{createdByUser}}&nbsp; _________________</span>
            </div>
            <div class="mt-3" style="font-size: 8pt">
                <span>{{company}}, {{companyContactAddress}}, {{companyContactPhoneNumbers}}</span>
                <span class="float-right">{{companyWebSite}}</span>
            </div>
            <div style="margin-top: 10px; width: 100%; border-bottom: #000 dotted 2px"></div>
        </div>

        <!--Заявление на открытие 3х фазного бытового абонента (до 10кВт) КЫРГ-->
        <div v-if="docBlankUid===1 && lang==='kg'" class="parent-container">
            <div>
                <div class="d-inline-block">
                    <span class="font-weight-bolder">Арыз №: {{docBlankUid+"-"+registrationNum}}<br/></span>
                    <span>{{this.dt}}</span>
                </div>
                <div class="float-right w-300px clear-fix">
                    <p>
                        {{resDeclension1}} башчысы<br/>
                        {{resHeadInfoDeclension1}}<br/>
                        Жазуучу: <span class="font-weight-bolder">{{subscriber}}</span><br/>
                        Дареги: <span class="font-weight-bolder">{{address}}</span><br/>
                        Телефон номери: <span class="font-weight-bolder">{{phoneNumbers}}</span><br/>
                    </p>
                </div>
            </div>
            <div class="clear-fix"/>
            <div class="mt-5">
                <h3 class="text-center">Арыз</h3>
            </div>
            <div class="mt-5">
                <p style="text-indent: 50px; text-align: justify; margin-bottom: 0">
                    Турак жайды _____ кВт тиричилик муктаждыктары үчүн электр энергиясы менен камсыздоого жана электр
                    эсептегич орнотууга, 0,4 кВ электр тармактарына жаңы абонент катары каттоого жана кошууга,
                    техникалык шарттарды алууга уруксат берүүңүздөрдү суранам.
                </p>
                <ul class="ml-15">
                    <li>Паспорттун көчүрмөсү (*)</li>
                    <li>Кыймылсыз мүлккө белгилөө укугу жөнүндө документтин көчүрмөсү (*)</li>
                    <li>Жашаган жеринен күбөлүктүн көчүрмөсү (*)</li>
                </ul>
            </div>
            <div class="mt-10">
                Датасы: {{this.dtShort}}-ж.
                <span class="float-right mr-20">{{subscriber}}
                    <span class="ml-5">____________________</span>
                </span>
            </div>
            <div style="margin-top: 30px; width: 100%; border-bottom: #000 dotted 2px"></div>
            <div class="text-center font-weight-bolder font-size-sm mt-1">Арыз берүүчүгө берилүүчү талон</div>
            <div class="mt-3 w-100">
                <div class="d-flex flex-row justify-content-between w-100">
                    <div class="mt-2">
                        <img src="media/logos/logo.jpg" width="60" height="60"/>
                    </div>
                    <div class="w-225px mt-4">
                        <h3 class="font-weight-bolder mb-0">Арыз №: {{docBlankUid+"-"+registrationNum}}<br/></h3>
                        <span>{{dtShort}}</span>
                    </div>
                    <div class="w-450px">
                        <div class="p-1 ml-22 font-size-sm overflow-auto" style="border: #000 1px dotted">
                            <img :src="getImgLink()" width="70" height="70" class="float-left d-block"/>
                            <span class="d-block mt-2 ml-24">Тиркеменин статусуна көз салуу үчүн kyzmat.oshelectro.kg
                                сайтына кириңиз же болбосо QR-кодду сканерлеңиз.</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="clear-fix"/>
            <div class="mt-3">
                <div class="float-left">Арыз берүүчү жөнүндө маалымат:</div>
                <div class="ml-2 d-inline-block pb-0 overflow-hidden"
                     style="border-bottom: #000 solid 1px; width: 71.5%">
                    {{subscriber}}, {{address}}, {{phoneNumbers}}
                </div>

            </div>
            <div class="mt-2">
                <span>Арыз кабыл алуучу:&nbsp; {{createdByUser}} &nbsp;_________________</span>
            </div>
            <div class="mt-3" style="font-size: 8pt">
                <span>{{company}}, {{companyContactAddress}}, {{companyContactPhoneNumbers}}</span>
                <span class="float-right">{{companyWebSite}}</span>
            </div>
            <div style="margin-top: 10px; width: 100%; border-bottom: #000 dotted 2px"></div>
        </div>

        <!--Заявление на открытие 3х фазного бытового абонента (свыше 10кВт) РУС -->
        <div v-if="docBlankUid===2 && lang==='ru'" class="parent-container">
            <div>
                <div class="d-inline-block">
                    <span class="font-weight-bolder">Заявка №: {{docBlankUid+"-"+registrationNum}}<br/></span>
                    <span>от {{this.dt}}</span>
                </div>
                <div class="float-right w-300px clear-fix">
                    <p>
                        Начальнику {{resDeclension1}}<br/>
                        {{resHeadInfoDeclension1}}<br/>
                        Заявитель: <span class="font-weight-bolder">{{subscriber}}</span><br/>
                        Адрес: <span class="font-weight-bolder">{{address}}</span><br/>
                        Номер телефона: <span class="font-weight-bolder">{{phoneNumbers}}</span><br/>
                    </p>
                </div>
            </div>
            <div class="clear-fix"/>
            <div class="mt-5">
                <h3 class="text-center">Заявление</h3>
            </div>
            <div class="mt-5">
                <p style="text-indent: 50px; text-align: justify; margin-bottom: 0">
                    Прошу Вас дать разрешение на получение технических условий на электроснабжение жилого дома для
                    бытовых нужд на _____ кВт и на установку электрического счетчика, регистрацию и подключение к
                    электрическим сетям 0,4 кВ, как новый абонент.
                </p>
                <ul class="ml-15">
                    <li>Копия паспорта заявителя (*)</li>
                    <li>Копия документа на право устанавливаемого на недвижимое имущество (*)</li>
                    <li>Копия справки с места жительства (*)</li>
                </ul>
            </div>
            <div class="mt-10">
                Дата: {{this.dtShort}} г.
                <span class="float-right mr-20">{{subscriber}}
                    <span class="ml-5">____________________</span>
                </span>
            </div>
            <div style="margin-top: 30px; width: 100%; border-bottom: #000 dotted 2px"></div>
            <div class="text-center font-weight-bolder font-size-sm mt-1">ОТРЫВНОЙ ТАЛОН (передается заявителю)</div>
            <div class="mt-3 w-100">
                <div class="d-flex flex-row justify-content-between w-100">
                    <div class="mt-2">
                        <img src="media/logos/logo.jpg" width="60" height="60"/>
                    </div>
                    <div class="w-225px mt-4">
                        <h3 class="font-weight-bolder mb-0">Заявка №: {{docBlankUid+"-"+registrationNum}}<br/></h3>
                        <span>Дата заявки: {{dtShort}}</span>
                    </div>
                    <div class="w-450px">
                        <div class="p-1 ml-22 font-size-sm overflow-auto" style="border: #000 1px dotted">
                            <img :src="getImgLink()" width="70" height="70" class="float-left d-block"/>
                            <span class="d-block mt-5 ml-24">Для отслеживания статуса заявки перейдите на сайт
                                kyzmat.oshelectro.kg или отсканируйте QR-код</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="clear-fix"/>
            <div class="mt-3">
                <div class="float-left">Данные заявителя:</div>
                <div class="ml-2 d-inline-block pb-0 overflow-hidden"
                     style="border-bottom: #000 solid 1px; width: 83.5%">
                    {{subscriber}}, {{address}}, {{phoneNumbers}}
                </div>

            </div>
            <div class="mt-2">
                <span>Заявка принята:&nbsp; {{createdByUser}}&nbsp; _________________</span>
            </div>
            <div class="mt-3" style="font-size: 8pt">
                <span>{{company}}, {{companyContactAddress}}, {{companyContactPhoneNumbers}}</span>
                <span class="float-right">{{companyWebSite}}</span>
            </div>
            <div style="margin-top: 10px; width: 100%; border-bottom: #000 dotted 2px"></div>
        </div>

        <!--Заявление на открытие 3х фазного бытового абонента (свыше 10кВт) КЫРГ -->
        <div v-if="docBlankUid===2 && lang==='kg'" class="parent-container">
            <div>
                <div class="d-inline-block">
                    <span class="font-weight-bolder">Арыз №: {{docBlankUid+"-"+registrationNum}}<br/></span>
                    <span>{{this.dt}}</span>
                </div>
                <div class="float-right w-300px clear-fix">
                    <p>
                        {{resDeclension1}} башчысы<br/>
                        {{resHeadInfoDeclension1}}<br/>
                        Жазуучу: <span class="font-weight-bolder">{{subscriber}}</span><br/>
                        Дареги: <span class="font-weight-bolder">{{address}}</span><br/>
                        Телефон номери: <span class="font-weight-bolder">{{phoneNumbers}}</span><br/>
                    </p>
                </div>
            </div>
            <div class="clear-fix"/>
            <div class="mt-5">
                <h3 class="text-center">Арыз</h3>
            </div>
            <div class="mt-5">
                <p style="text-indent: 50px; text-align: justify; margin-bottom: 0">
                    Турак жайды _____ кВт тиричилик муктаждыктары үчүн электр энергиясы менен камсыздоого жана электр
                    эсептегич орнотууга, 0,4 кВ электр тармактарына жаңы абонент катары каттоого жана кошууга,
                    техникалык шарттарды алууга уруксат берүүңүздөрдү суранам.
                </p>
                <ul class="ml-15">
                    <li>Паспорттун көчүрмөсү (*)</li>
                    <li>Кыймылсыз мүлккө белгилөө укугу жөнүндө документтин көчүрмөсү (*)</li>
                    <li>Жашаган жеринен күбөлүктүн көчүрмөсү (*)</li>
                </ul>
            </div>
            <div class="mt-10">
                Датасы: {{this.dtShort}}-ж.
                <span class="float-right mr-20">{{subscriber}}
                    <span class="ml-5">____________________</span>
                </span>
            </div>
            <div style="margin-top: 30px; width: 100%; border-bottom: #000 dotted 2px"></div>
            <div class="text-center font-weight-bolder font-size-sm mt-1">Арыз берүүчүгө берилүүчү талон</div>
            <div class="mt-3 w-100">
                <div class="d-flex flex-row justify-content-between w-100">
                    <div class="mt-2">
                        <img src="media/logos/logo.jpg" width="60" height="60"/>
                    </div>
                    <div class="w-225px mt-4">
                        <h3 class="font-weight-bolder mb-0">Арыз №: {{docBlankUid+"-"+registrationNum}}<br/></h3>
                        <span>{{dtShort}}</span>
                    </div>
                    <div class="w-450px">
                        <div class="p-1 ml-22 font-size-sm overflow-auto" style="border: #000 1px dotted">
                            <img :src="getImgLink()" width="70" height="70" class="float-left d-block"/>
                            <span class="d-block mt-2 ml-24">Тиркеменин статусуна көз салуу үчүн kyzmat.oshelectro.kg
                                сайтына кириңиз же болбосо QR-кодду сканерлеңиз.</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="clear-fix"/>
            <div class="mt-3">
                <div class="float-left">Арыз берүүчү жөнүндө маалымат:</div>
                <div class="ml-2 d-inline-block pb-0 overflow-hidden"
                     style="border-bottom: #000 solid 1px; width: 71.5%">
                    {{subscriber}}, {{address}}, {{phoneNumbers}}
                </div>

            </div>
            <div class="mt-2">
                <span>Арыз кабыл алуучу:&nbsp; {{createdByUser}} &nbsp;_________________</span>
            </div>
            <div class="mt-3" style="font-size: 8pt">
                <span>{{company}}, {{companyContactAddress}}, {{companyContactPhoneNumbers}}</span>
                <span class="float-right">{{companyWebSite}}</span>
            </div>
            <div style="margin-top: 10px; width: 100%; border-bottom: #000 dotted 2px"></div>
        </div>
    </b-overlay>
</template>

<script>
    import axios from "axios";

    export default {
        name: "BlankNewSubscriber",
        data() {
            return {
                userData: this.$store.getters.getUserData,
                loadProcessing: 0,

                err: false,
                errText: "",
                errVariant: "danger",

                lang: 'ru',    //
                recordUid: "",
                sessionUid: "",
                docBlankUid: -1,

                resHeadInfo: "",
                res: "",
                resHeadInfoDeclension1: "",
                resDeclension1: "",
                registrationNum: "",
                subscriber: "",
                address: "",
                phoneNumbers: "",
                dt: "",
                dtShort: "",
                createdByUser: "",
                company: "",
                companyWebSite: "",
                companyContactAddress: "",
                companyContactPhoneNumbers: "",
            }
        },
        created() {
            document.title = "ЭЦОН - Печать бланка"

            this.lang = this.$route.query.lang || "kg"
            this.sessionUid = this.$route.query.sessionUid || ""
            this.recordUid = this.$route.query.recordUid || ""
            this.docBlankUid = parseInt(this.$route.query.docBlankUid) || 0

            document.title = "ЭЦОН - Печать бланка " + (this.lang === "ru" ? "(рус.)" : "(кырг.)")
        },
        mounted() {
            this.loadData()
        },
        methods: {
            errTextHide() {
                this.err = false
                this.errText = ""
            },
            errTextShow(msg, variant = "danger", withScroll = true) {
                if (withScroll)
                    window.scrollTo(0, 0)
                this.errText = msg
                this.errVariant = variant
                this.err = true
            },
            loadData() {
                let l = (this.lang === "ru") ? 0 : 1

                this.loadProcessing++
                axios.post("/ws/ws.svc/GetDocsBlankInfo", {
                        'Session_UID': this.sessionUid,
                        'F_DocBlank_UID': this.docBlankUid,
                        'F_Language_UID': l,
                        'F_UID': this.recordUid,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response) ||
                            this.isUndefined(resp.data.data)) {
                            this.errTextShow("Неверный формат ответа.", "danger", true)
                        } else {
                            if (resp.data.success) {
                                if (resp.data.data.toString().length > 0) {
                                    let result = JSON.parse(resp.data.data)
                                    if (!this.isUndefined(result)) {
                                        this.res = result.RES.toString() || ""
                                        this.resDeclension1 = result.RESDeclension1.toString() || ""
                                        this.resHeadInfo = result.RESHeadInfo.toString() || ""
                                        this.resHeadInfoDeclension1 = result.RESHeadInfoDeclension1.toString() || ""
                                        this.registrationNum = result.RegistrationNum.toString() || ""
                                        this.dt = result.DT.toString() || ""
                                        this.dtShort = result.DTShort.toString() || ""
                                        this.subscriber = result.Subscriber.toString() || ""
                                        this.address = result.Address.toString() || ""
                                        this.phoneNumbers = result.PhoneNumbers.toString() || ""
                                        this.createdByUser = result.CreatedByUser.toString() || ""
                                        this.company = result.Company.toString() || ""
                                        this.companyWebSite = result.CompanyWebSite.toString() || ""
                                        this.companyContactAddress = result.CompanyContactAddress.toString() || ""
                                        this.companyContactPhoneNumbers = result.CompanyContactPhoneNumbers.toString() || ""
                                    } else {
                                        this.errTextShow(resp.data.response.toString(), "danger", true)
                                    }
                                }
                            } else {
                                this.errTextShow(resp.data.response.toString(), "danger", true)
                            }
                        }
                        this.loadProcessing--
                    })
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                        this.loadProcessing--
                    })
            },
            btnPrintClicked() {
                window.print()
            },
            btnCloseClicked() {
                window.close()
            },
            getImgLink() {
                let l = (this.lang === "ru") ? 0 : 1
                return `ws/blankqrcode?session_uid=${this.sessionUid}&docblank_uid=${this.docBlankUid}&uid=${this.recordUid}&l=${l}`
            }
        },
        watch: {
            loadProcessing: function () {
                this.$store.commit('set', ["showSpinner", this.loadProcessing > 0])
            },
        }
    }
</script>

<style scoped>
    .tools-container {
        margin: 20px auto 0 auto;
        width: 900px;
    }

    .parent-container {
        background-color: #fff;
        margin: 20px auto;
        padding: 40px 40px 40px 80px;
        width: 900px;
        min-height: 500px;
        /*height: 1273px;*/
        font-family: "Calibri", "Helvetica", "sans-serif";
        font-size: 11pt !important;
    }

    .clear-fix {
        clear: both;
    }

    @media print {
        @page {
            size: A4;
            margin: 0;
            font-family: "Calibri", "Helvetica", "sans-serif";
            color: #000 !important;
        }

        .parent-container {
            width: 100%;
        }

        .no-print {
            display: none;
        }
    }

</style>